import { OnClickLink } from "@sorcery/ui";

export const FilterItem = ({
  label,
  onClick,
  active,
}: {
  label: string;
  onClick: () => void;
  active?: boolean;
}) => {
  return (
    <OnClickLink onClick={onClick}>
      <li
        className={`hover:text-primary cursor-pointer pr-4
        capitalize text-[hsla(0,0%,100%,.8)] transition-all hover:text-[rgba(0,0,0,0.7)]
        ${active && "font-bold !text-white"}`}
      >
        {label}
      </li>
    </OnClickLink>
  );
};
